export default class Waive {
    "waiveId": number;
    "name": string;
    "code": string;
    "description": string;
    "waiveType": string;
    "parentWaiveId": number | undefined | null;
    "summaryPosition": string;
    "configJson": string;
} 
